export const GARMENT_PROMPTS: Record<string, string> = {
  top: `-----------------------------------
🔒 STRICT PRODUCT LOCK (HIGHEST PRIORITY)
-----------------------------------
The garment from {{PRODUCT_REF}} must be reproduced EXACTLY as-is.
DO NOT modify, reinterpret, or redesign the product in any way.
Preserve 100% accurately:
- Exact color tone (no warm/cool shift)
- Fabric texture and material appearance
- Fit and silhouette
- Stitching, seams, and construction details
- Patterns, prints, embroidery placement
- Neckline, sleeves, hemline, proportions
The output must look like:
→ The SAME product digitally placed on the model
NOT:
→ A similar or inspired version
-----------------------------------
🔒 MODEL LOCK (SECOND PRIORITY)
-----------------------------------
Replicate {{MODEL_REF}} exactly:
- Same face, hair, and makeup
- Same expression and pose
-----------------------------------
🎥 SCENE & PHOTOGRAPHY LOCK
-----------------------------------
Match {{MODEL_REF}} exactly in:
- Background and environment
- Lighting direction, softness, and color tone
- Camera quality, lens, depth of field
- Framing and composition
- Overall realism and natural look
⚠️ Avoid any AI-stylized or synthetic look
-----------------------------------
👗 STYLING RULE
-----------------------------------
- Keep styling identical to {{MODEL_REF}}
- Do not add new accessories unless already present
- Ensure the garment fits naturally
-----------------------------------
📸 OUTPUT REQUIREMENT
-----------------------------------
Generate a SINGLE IMAGE containing a 2x2 GRID showing the same outfit from 4 angles:
1. Front view — full body
2. Back view — full body
3. Left side view — ZOOMED-IN (mid-torso to head framing, focus on upper garment)
4. Right side view — full body
-----------------------------------
⚠️ STRICT RULES
-----------------------------------
- Frames 1, 2, and 4 must be full body (no cropping)
- Frame 3 must be zoomed-in (upper body only)
- No distortion or body part duplication
- No merging errors between grid panels
- No white lines, borders, or dividers between grid panels — grid cells must be seamlessly joined
- Consistent lighting and scale across all 4 frames
- Photorealistic — must look like a real fashion shoot
-----------------------------------
✨ FINAL GOAL
-----------------------------------
A highly realistic fashion lookbook grid where:
- The garment is 100% identical to the reference
- The model and scene match the reference perfectly
- The output looks indistinguishable from a real photoshoot`,

  bottom: `-----------------------------------
🔒 STRICT PRODUCT LOCK (HIGHEST PRIORITY)
-----------------------------------
The bottom garment from {{PRODUCT_REF}} must be reproduced EXACTLY as-is.
DO NOT modify, reinterpret, or redesign the product in any way.
Preserve 100% accurately:
- Exact color tone (no warm/cool shift)
- Fabric texture and material appearance
- Fit and silhouette (waistband, hem, flare)
- Stitching, seams, pockets, zipper details
-----------------------------------
🔒 MODEL LOCK (SECOND PRIORITY)
-----------------------------------
Replicate {{MODEL_REF}} exactly:
- Same face, hair, and makeup
- Same expression and pose
-----------------------------------
🎥 SCENE & PHOTOGRAPHY LOCK
-----------------------------------
Match {{MODEL_REF}} exactly in:
- Background and environment
- Lighting direction and overall color tone
-----------------------------------
📸 OUTPUT REQUIREMENT
-----------------------------------
Generate a SINGLE IMAGE containing a 2x2 GRID showing the bottom outfit from 4 angles:
1. Front view — full body
2. Back view — full body
3. Left side view — ZOOMED-IN on lower waist/legs
4. Right side view — full body`,

  dress: `-----------------------------------
🔒 STRICT PRODUCT LOCK (HIGHEST PRIORITY)
-----------------------------------
The dress from {{PRODUCT_REF}} must be reproduced EXACTLY as-is.
DO NOT modify, reinterpret, or redesign the product in any way.
Preserve 100% accurately:
- Exact color tone, pattern, and embroidery
- Fabric flow, texture, and silhouette
-----------------------------------
🔒 MODEL LOCK (SECOND PRIORITY)
-----------------------------------
Replicate {{MODEL_REF}} exactly:
- Same face, hair, and makeup
-----------------------------------
📸 OUTPUT REQUIREMENT
-----------------------------------
Generate a SINGLE IMAGE containing a 2x2 GRID showing the dress from 4 angles:
1. Front view — full body
2. Back view — full body
3. Mid-shot view — waist up
4. Right side view — full body`
};
